module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "ch1"
    }
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "page1"
    }
  })]), _c('a', {
    attrs: {
      "id": "page1"
    }
  }, [_c('p', {
    staticClass: "part_no"
  }, [_c('span', [_vm._v("DAY 1")])]), _vm._v(" "), _c('p', {
    staticClass: "part_title"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Saturday")])])]), _c('div', {
    staticClass: "pbk"
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }), _c('p', [_c('a', {
    attrs: {
      "id": "page1"
    }
  }), _c('a', {
    attrs: {
      "id": "page3"
    }
  })]), _c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('span', [_vm._v("1")])]), _vm._v(" "), _c('p', [_vm._v("Whatever happened, he just didn’t want to make a complete idiot of himself.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Detective Captain Benny Griessel was wearing a new suit of clothes that he could ill afford. There was a bouquet of flowers on the passenger seat, his hands gripping the steering wheel were clammy, and with all his being he yearned for the healing, calming powers of alcohol. Tonight he must just please not make a total idiot of himself. Not in front of Alexa Barnard, not in front of all the stars of the music world, not after all the past week’s planning and preparation.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He’d started on Monday, with a haircut. Tuesday, Mat Joubert’s wife, Margaret, had been his style consultant at Romens in Tyger Valley. ‘It’s smart casual, Benny, just a pair of chinos and a smart shirt,’ she had said patiently in her charming English accent.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘No, I want a jacket too.’ Griessel had dug in his heels, terrified of being caught between too ‘casual’ and not ‘smart’ enough. There would be some smart people there.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He had wanted a tie as well, but Margaret had put her foot down. ‘Overdressed is worse than underdressed. No tie.’ They had left with khaki chinos, a light blue cotton shirt, black belt, black shoes, a fashionable black jacket, and a credit card bill that made him shudder.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Since Wednesday he had been mentally preparing himself. He knew this thing, this event, had the potential to overwhelm him completely. His greatest fear was that he would swear, because that was what he always did when he got stressed. He would have to guard his tongue, all evening. No police-speak, no crude language, talk nice, stay calm. He had gone through it all in his imagination, visualised it, as Doc Barkhuizen, his sponsor at Alcoholics Anonymous, had prescribed.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("To Anton L’Amour he would say: ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kouevuur ")]), _vm._v("is brilliant guitar.’")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_vm._v("That’s all, no waxing lyrical and talking shit. To Theuns Jordaan: ‘I like your work a lot.’ That was a good thing to say, full of respect and appreciation, dignified. Lord, and if Schalk Joubert was there, he, Benny Griessel would take a deep breath, shake his hand and just say: ‘Pleased to meet you, it’s a great honour.’ Then he had better walk")]), _c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_vm._v(" away before the flood of words of hero worship, admiration of Joubert’s mastery of bass guitar, spilled over all his careful defences.")])]), _c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("Then, his biggest worry: Lize Beekman.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("If he could just have one drink before he met her. To keep his nerves from getting out of control. He would have to dry his hand on his new trousers first, he couldn’t greet Lize Beekman with his palm all sweaty. ‘Miss Beekman, it’s an exceptional honour. Your music gives me great pleasure.’ And she would say ‘thank you’, and he would leave it at that and go and find Alexa, because that was the only way he would keep from making a total idiot of himself.")]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("The white Chana panel van stopped under the trees in Second Avenue, between the Livingstone High School and the back yard of the South African Police Service’s Claremont Station.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("It was a nondescript vehicle, a 2009 model bearing the marks of hard labour – a dent in the front bumper, scrapes and scratches on the doors at the back. The windows in the middle and rear were blanked out with cheap white paint. The side panels differed slightly in colour from the rest of the vehicle.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Behind the wheel, the sniper turned off the engine, put both hands on his knees and sat, for just a moment, dead still.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He wore a blue labourer’s overall, slightly faded. Long blond hair hung down his back, a brown baseball cap was pulled down low over his eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("With deliberate focus he looked out of the passenger window at the deserted school grounds. Then right. He studied the high fence across the street, the double wire gate, and behind it, the SAPS yard, wrapped in the early-evening shadow of Table Mountain. It was quiet and deserted.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He made sure both doors in front were locked, clambered over the seat to the back. The storage space was untidy, boxes and trunks of metal, wood and cardboard. He sat down on a wooden box and loosened the home-made screen of faded yellow material from the carpet-lined roof. It separated him from the driver’s cab, making him invisible to passers-by.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_vm._v("He took off the cap, laid it to one side, aware that he was breathing faster, his hands trembling slightly. He relaxed his shoulders with a forced sigh, bent down, opened a long, battered tool chest, and took")]), _c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_vm._v(" out the removable tray. It was heavy, filled with well-worn tools – hammers, a collection of screwdrivers, cutters and pliers, metal saw blades. He put it gently down beside the chest, on the rubber matting covering the floor of the Chana.")])]), _c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("There were two articles in the bottom of the red box – a firearm and a K-Way Kilimanjaro Trekking Pole.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He took out the hiking pole first, and propped it against his shoulder, picked up the rifle, pressed the silencer carefully through the black wrist strap on the end of the stick, so that the telescope of the rifle was not interfered with, and twisted the stick anti-clockwise until the loop was tight.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He pressed his cheek to the rifle butt, tested the height of the supporting hiking pole, and made an adjustment.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He slid the Chana’s right side panel three centimetres to the right with the small handle he had attached. Then the magnetic panel outside, so he could aim the barrel and telescope outwards.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He pressed the rifle butt to his shoulder and looked at the SAPS car park through the scope. He adjusted the focus.")]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("In front of the big Victorian house in Brownlow Street, Griessel picked up the bouquet, got out of the car and walked through the little garden gate to the front door.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Alexa Barnard was in the process of renovating the house. The ugly giant cactus against the front fence had been recently removed, the painters’ scaffolding stood high against the walls.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("It was all part of her recovery, he thought. Her new life.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He came to a halt at the front door, looked at his shoes. They gleamed.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He took a deep breath. What if he had misunderstood the whole thing, and it was a black-tie affair tonight, and Alexa opened the door in some exotic evening dress? Or it was totally informal, denims and open-neck shirts? He had never been to a music industry cocktail party before.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He rang the doorbell, heard her coming down the stairs.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The door opened. She stood in front of him.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jissis")]), _vm._v(",’ said Griessel.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("*   *   *")])])]), _c('p', [_c('a', {
    attrs: {
      "id": "page5"
    }
  }), _c('a', {
    attrs: {
      "id": "page6"
    }
  })]), _c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('p', [_vm._v("Through the peephole the sniper saw the police van drive by close to the Chana. It slowed, ready for the turn in at the wide gate.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He waited for it to reappear in the car park in his field of vision. He kept his cheek pressed to the rifle butt, followed the van through the scope.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Only one occupant, in uniform.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The van drove over the tarred surface to the middle of the open area. It parked behind two other SAPS vehicles where he couldn’t see it.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Between seventy and eighty metres, he guessed.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("As he aimed the cross hairs on the front of one of the vehicles, waiting for the policeman to appear, he suddenly became aware of the beating of his heart.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He took a deep breath.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The uniform appeared in the telescope. A constable.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Difficult shot, moving target.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He aimed low, followed the movement, forced himself to stick to his procedure: keep the horizontal axis of the scope level, cross hairs on the target, breathe out, press the trigger gently, keep your eye open.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The rifle kicked softly against his shoulder, the muffled blurt of the shot was louder than he had expected, within the Chana’s enclosed space.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("A miss.")]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("‘You look . . .’ Griessel wanted to say ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("befok")]), _vm._v("’, but he restrained himself, searched desperately for an acceptable word, one that would do her breathtaking appearance justice. ‘. . . fantastic.’ She was standing there in a strapless black dress that draped to her ankles, a wide, tan leather belt just below her generous breasts, light brown platform sandals.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("And her face – he had never seen her like this: carefully and skilfully made up, red, full lips, blonde hair cut and coloured, big silver hearts as earrings, her eyes a deep green behind long lashes.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("For one fleeting moment he wondered, after everything, whether he would kiss her tonight for the first time.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She laughed and looked at him approvingly. ‘You too, Benny.’ Then, ‘Are the flowers for me?’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Oh. Yes . . .’ He held them out to her awkwardly.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("There was a blush on her cheeks, genuine appreciation for him, for this gesture.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page6"
    }
  }), _c('a', {
    attrs: {
      "id": "page7"
    }
  })]), _c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Thank you very much.’ She stepped forward and kissed Griessel on the cheek.")]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("He knew from experience the shot was barely audible outside, thanks to the silencer and the pieces of carpet glued to the Chana’s interior. His palms perspired against the gun and his heart thumped. He worked the bolt, and the bullet casing sprang out, clinked against one of the toolboxes. He pushed another round into the chamber. He moved the weapon slightly, saw through the scope that the constable was unaware of the failed shot, his head turned away towards the mountain.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He aimed down, found the constable’s legs in the cross hairs.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He led two, three centimetres ahead of moving legs, knee height, the panic blooming from the pit of his stomach, breathe, breathe, exhale slowly . . . He squeezed the trigger. Saw the constable fall.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Relief. Smell of cordite in his nostrils.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Then, urgency, knowing he must concentrate now, the next sixty seconds were make or break, do everything exactly according to the plan.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Unwind the strap of the support stick. Withdraw the rifle from the loop. Lay the weapon in the toolbox. Put the tray over it. Close the box. The pole can stay there.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Lift up the cloth drape.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The cap. Put on the cap.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He climbed through to the driver’s seat.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Do not look at the target, do not, but the anxiety threatened to overwhelm him, so he quickly turned his head to see. The constable was eighty metres away, lying there. He was looking down, probably at his leg.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Look in front of you.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Turn the key, start the Chana, pull away slowly, only ten metres and you will be out of sight, seconds, not enough for the constable to see you, to notice, he will be in shock, confused. Don’t attract attention, do everything calmly, normally.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He put the vehicle in gear. And drove away.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page7"
    }
  }), _c('a', {
    attrs: {
      "id": "page8"
    }
  })]), _c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', [_vm._v("At the entrance to the Artscape Chandelier Foyer Griessel stared at the giant poster. In big letters it proclaimed "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Anton Goosen Birthday Concert, Friday 4 March, Grand Arena")]), _vm._v(", with a photo below of all the stars who would be performing there in a week’s time. Alexa Barnard was the focal point, right in the middle, just below the smaller announcement which used her stage name: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Xandra Barnard is back!")])]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("And here he was with "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that ")]), _vm._v("legend on the arm of his new jacket. He swallowed hard, and held himself together.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Inside. Lots of people. He quickly surveyed the men, what they were wearing. Relief washed over him, because there were a lot of jackets. He relaxed a little, everything was going to be OK.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Heads turned towards Alexa, people called out her name, and suddenly they were surrounded"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(". ")]), _vm._v("Alexa let go of his arm and began greeting people. Griessel stood back. He had suspected this would happen and was happy she was getting this reception. Last week she had been nervous and had told him: ‘I’ve been out of it for so long, Benny. And that whole thing with Adam’s death . . . I don’t know what to expect.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Adam had been her husband. Benny had investigated his murder; that was how he had met her.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘You’re Paul Eilers, the actor,’ someone said right beside him. Then he realised the pretty young woman was talking to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("him")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘No,’ he said. ‘I’m Benny Griessel.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘I could have sworn you were Paul Eilers,’ she said, disappointed, and then she was gone.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He recognised some of the music stars. Laurika Rauch folding Alexa’s hands in hers, saying something with great tenderness. Karen Zoid and Gian Groen in conversation. Emo Adams making Sonja Herholdt laugh out loud.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_vm._v("Where was Lize Beekman? A waiter pushed through the mass of bodies, came past with a tray full of champagne glasses, offered him one. He stared at the golden liquid, the bubbles lazily drifting upwards, and felt the stirring inside,")]), _c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_vm._v(" the desire. He came to his senses, shook his head. No, thank you.")])]), _c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("Two hundred and twenty-seven days without a drink.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Maybe he ought to get himself a soft drink, something to hold in his hand, rather than just standing here, a dull island in a sea of glitterati. Look at Alexa, she was at home, in her element, she glowed.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Jissis")]), _vm._v(". What was he doing here?")]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("When he met Schalk Joubert the moment was almost too big for him.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Schalk, this is Benny Griessel, he also plays bass,’ Alexa introduced him, and he could feel his face turn red. With a trembling hand, ‘Pleased to meet you, it’s a helluva privilege.’ His voice was hoarse and he was startled by the swear word that slipped out.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Ah, a brother. Thank you very much, the privilege is all mine,’ said Schalk Joubert easily and comfortably, his tone smoothing away Griessel’s fears, making him relax. The enormous compliment of ‘a brother’ filled Griessel with gratitude, so that, in the light of Alexa’s encouraging smile, he found the courage to strike up a conversation with Theuns Jordaan and Anton L’Amour. He asked them how "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kouevuur ")]), _vm._v("had been put together. And then, emboldened by their generosity: ‘So when are you going to record “Hexriviervallei” properly, a complete track? That song deserves it.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He began to unwind, chatting here, laughing there, wondering what he had been so worried about. He felt almost proud of himself, and then Alexa tugged at his arm and he turned around and saw Anton Goosen "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("and ")]), _vm._v("Lize Beekman, side by side, right in front of him, conspiratorial, a moment of silence that opened up in the hubbub and it was too sudden and too much and his brain shut down and his heart beat wildly and he grabbed for the tall, beautiful, blonde singer’s hand, completely star-struck, and all that came out of his mouth, the word idiotically long and drawn-out and clear in the silence, was: ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fok")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("And then his cellphone began to ring in his jacket pocket.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He just stood there. Frozen.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Somewhere in his head the impulse came: Do something.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He dropped Lize Beekman’s hand. Shame and humiliation burning through him, he mumbled, ‘Excuse me.’ He fumbled for his phone, turned away, pressed the instrument to his ear.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Hello.’ Even his own voice sounded strange to him.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page9"
    }
  }), _c('a', {
    attrs: {
      "id": "page10"
    }
  })]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Benny, I need you,’ said Brigadier Musad Manie, commanding officer of the Hawks. ‘Like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("now")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("He drove, too fast, angry with himself, angry with Alexa, how could she do that to him? Angry with the cellphone for ringing, he could definitely have recovered from his massive mistake, he could have added something, his practised sentence of ‘this is a special privilege’, it would have defused the whole mess. Angry with the brigadier making him come in on a Saturday night, his weekend off, angry because he couldn’t get the damning chorus out of his head: he had made a complete and total arse of himself. That awful moment, the word uttered, hanging like a dead, black bird between him and Lize Beekman, everything frozen except the irritating ringing of his cellphone and the knowledge that sank down in him like lead: he had made a massive unforgivable arse of himself, in spite of all his resolutions and plans and preparations.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("It was really Alexa’s fault. She had wanted to know who he was keen to meet, two weeks ago already. From the beginning he had said nobody, he would just be around, available when she needed him. Because he knew he might lose it. But she had drawn the names out of him one by one, and she had said, ‘I really want to do this for you,’ and he had said, ‘No, please,’ but with ever diminishing conviction, because the prospect began to tempt him. Until he had agreed, for her sake, but the butterflies had been in his belly already, the faint terror, no, the premonition that he might not handle it well.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("His fault. Just his own fucking fault.")]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("He knew there was big trouble when he saw the three senior officers of the DPCI – the Directorate for Priority Crime Investigations – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("and ")]), _vm._v("General John Afrika, Western Cape head of Detective Services and Criminal Intelligence.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The burly Brigadier Musad Manie, commander of the Hawks, sat in the middle with a face of granite. On either side were Colonel Zola Nyathi, head of the Violent Crimes Group, and Griessel’s immediate boss, and Colonel Werner du Preez, group head of Crimes Against the State (CATS). Afrika was on the opposite side of the table.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("They greeted him, Manie invited him to sit down. Griessel saw there were files and documents in front of each of the senior officers.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page10"
    }
  }), _c('a', {
    attrs: {
      "id": "page11"
    }
  })]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Sorry to interrupt your evening, Benny,’ said the brigadier. ‘But we’ve got a problem.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘A nasty problem,’ said Afrika.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Colonel Nyathi nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The brigadier hesitated, holding his breath, as if there was a lot more to say. Then he reconsidered, pushed a sheet of paper across the table. ‘Let’s start with this.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Griessel pulled the paper towards him, began to read, conscious of the four sets of eyes on him.")]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("762a89z012@anonimail.com")]), _vm._v(" "), _c('p', [_vm._v("Sent: Saturday 26 February. 06.51")]), _vm._v(" "), _c('p', [_vm._v("To: j.afrika@saps.gov.za")]), _vm._v(" "), _c('p', [_vm._v("Re: Hanneke Sloet – you were warned")]), _vm._v(" "), _c('p', [_vm._v("Today it is precisely 40 days since Hanneke Sloet was murdered. That is 40 days of cover-up. You know why she was murdered.")]), _vm._v(" "), _c('p', [_vm._v("This is my fifth message but you don’t listen. Now you leave me no choice. Today I will shoot a policeman. In the leg. And every day I will shoot a policeman, until you charge the murderer.")]), _vm._v(" "), _c('p', [_vm._v("If you don’t have a report in the newspaper tomorrow that says you have reopened the Sloet case, the next bullet will not be in the leg.")]), _vm._v(" "), _c('p', {
    staticClass: "margind"
  }, [_vm._v("No name. Griessel looked up.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘As you can see, this was sent this morning,’ said the brigadier. ‘And tonight Constable Brandon April was shot by a sniper in the leg in the parking lot of the Claremont Station. Just before seven.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Long distance shot,’ said Afrika. ‘They’re still looking for the bastard’s vantage point.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘The knee is bad,’ said Nyathi. ‘Shattered.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘A young man,’ said Afrika. ‘Won’t ever walk normally again. This crazy bastard . . .’ and he pointed at the email in Griessel’s hands, ‘has written to me four times. Very confused emails, they don’t make sense.’ He tapped the file in front of him. ‘You’ll see.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The brigadier leaned forward. ‘We would like to announce that you will be leading the reopened investigation into the Sloet case, Benny.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘I personally asked the brigadier if we could give it to you,’ said Afrika.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page11"
    }
  }), _c('a', {
    attrs: {
      "id": "page12"
    }
  })]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Cloete is currently working on the Sunday papers, he says there’s a chance we can get something into the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Weekend Argus ")]), _vm._v("and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rapport")]), _vm._v("’s Cape section,’ said Manie. Cloete was the liaison officer of SAPS who handled the press.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘We are going on radio as well, but I don’t know if that will help,’ said Afrika.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘It’s a bit of a mess,’ said Nyathi, his frown deepening. ‘To say the least.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘If you’re willing, Benny. We will back you up. All of us.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Griessel put the sheet of paper down on the table, straightened his new, fashionable black jacket and asked: ‘Hanneke Sloet . . . she was the lawyer?’")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', [_vm._v("‘That’s right,’ said Manie and pushed the file across to Griessel.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Mid-January. Green Point investigated the case . . .’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Griessel took the fat pack of documents and tried to remember what he had heard about the Sloet murder. There had been a small media storm about six weeks back, his colleagues had discussed the case constantly.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Five blocks away from my office in her fancy apartment,’ said Afrika. ‘Nailed her.’ And then half apologetically he added: ‘With one helluva knife.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The brigadier sighed. ‘They found nothing. Nothing. Look at the investigation diary, you’ll see, they followed up everything.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Griessel opened the dossier at the SAPS5 form in Section C, quickly paged through it, saw the extensive, detailed notes. ‘You know how it’s been since the Steyn case,’ said Afrika. ‘Everyone makes doubly sure, nobody takes chances any more. The Sloet investigation was by the book. The forensics were good, the footwork was thorough, they talked to everyone who lived and breathed, there’s no motive that stands up to scrutiny.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Except that she was a lawyer,’ said Nyathi philosophically. ‘Big clients. Big money.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘True . . .’ said Afrika.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page12"
    }
  }), _c('a', {
    attrs: {
      "id": "page13"
    }
  })]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Crime of opportunity,’ said Nyathi. ‘Impossible case.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Afrika sighed. ‘Trouble is, she moved into the flat on the third of January, she was murdered on the eighteenth. She hadn’t even finished unpacking. Nobody could tell the Green Point detectives if anything was stolen.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Let’s not disclose everything,’ said Manie carefully to the general. ‘We want Benny to look at this with fresh eyes. Work through the file from the beginning, see what he can find.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Afrika nodded in agreement.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Griessel picked up the email. ‘Brigadier, what about this “cover-up . . . you know why she was murdered”?’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Before Manie could answer, Afrika said vigorously: ‘It’s rubbish, Benny, absolute rubbish. Take a look at his other emails. Dreadful insinuations. We are protecting the communists and the Antichrists and whatnot.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘The guy’s a loony,’ said Nyathi. ‘White supremacist, hates us, hates the government, hates gay people, hates everybody.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘A terrorist, that’s what he is, a terrorist hiding behind an anonymous email address. Untraceable.’ Afrika slid the thin folder that lay in front of him over to Benny as well. ‘Here are the other letters. You’ll see.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Was he supposed to investigate the sniper affair too?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The brigadier picked up on his uncertainty: ‘You know how it is with these crazies, Benny – sometimes they fixate on a specific case. But if there is a connection between the gunman and Sloet, and we have missed it . . . CATS are going to hunt the gunman. Colonel du Preez is the JOC leader.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Mbali will be our official investigator, Brigadier,’ said du Preez. ‘She arrived back from Amsterdam yesterday . . .’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Amsterdam, oh, Amsterdam,’ said Afrika, shaking his head, but with good humour.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("The unit had been abuzz the past week, over ‘the incident in Amsterdam’. The stout Mbali Kaleni, a member of du Preez’s CATS team for the past six months, had been one of a group of detectives taking a course in Holland. Something had happened to her – according to the bush telegraph it was a great embarrassment. But, despite pointed speculation in the corridors, nobody really knew what had")]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v(" happened. Except the top management, and they were as silent as the grave.")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("‘You will have your hands full, Benny, but it’s important that you know what progress CATS are making, what they are looking into. And if you find something that could help them . . .’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘You know how we work, Benny,’ said Colonel du Preez. ‘One big team . . .’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Griessel nodded again.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Nyathi folded his arms and sighed. ‘Benny, if word gets out there’s someone blackmailing us, shooting policemen . . . Feeding frenzy for the press, public panic.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Cloete will keep the constable’s knee out of the papers. Just so you know, Benny,’ said Manie. ‘Please be careful with the press. In any case, Adjutant-Officer Nxesi is the Green Point detective who handled the Sloet case. You can call him, any time, he’s ready to come in.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Our whole team is ready to support you,’ said Nyathi.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Not to put any extra pressure on you, Benny,’ Afrika said seriously, ‘but you must get moving. This mad bastard is going to keep on shooting policemen until you solve the case.’")]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("At half past ten on a Saturday night Griessel walked to his office down the deathly silent, wide corridors of the DPCI – the Hawks – building. He was amazed at the effect that the Steyn affair, which Manie had referred to a few minutes ago, had had on the SAPS this past year.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Estelle Steyn, a newly qualified young chef, had been strangled eighteen months ago in her Pinelands town house – with a piece of material, probably a tie. No signs of breaking and entering, theft or sexual assault – it must have been someone whom she knew and trusted. Like her tie-wearing fiancé, the sombre, emotionless KPMG consultant with cold eyes and a key to her door. Within seventy-two hours he had been arrested and charged, and the media and fascinated public immediately declared him guilty. Because Estelle Steyn was a joyous, lively bundle of sunny energy, a brilliant cook with a bright future according to her colleagues. Alongside her blonde, smiling beauty on the front pages of the papers, her fiancé’s photo looked brooding and forbidding, the taciturn stare turned away from the camera. Like a man burdened by his misdeeds.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page14"
    }
  }), _c('a', {
    attrs: {
      "id": "page15"
    }
  })]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("Then came the court case.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Like a pack of wild dogs, the defence ripped apart the carcass of poor crime-scene management, the narrow focus of the investigation, and the creative assumptions of the forensic testimony.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("After seven months of sensation, the fiancé walked away a free man.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The media scolded and squawked, the public were shocked and dumbstruck. Months later best-selling books by criminologists and forensics experts analysed and criticised every SAPS misstep. In parliament, time and again the opposition used the whole as a stick with which to beat the government – the damage and scandal would not go away.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The career of the investigating officer, Fanie Fick, was over. He was tucked away in the Information Management Centre (IMC) of the Hawks now, retrained and redeployed as a computer analyst, but everyone knew he would not be promoted again. Behind his back they talked about ‘Fanie Fucked’, the guy who relieved his pain after hours every day at the Drunken Duck in Stikland.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("That was why the Sloet file that Griessel carried to his office was so painfully detailed and ‘by the book’. The police service’s wounds were still raw, their honour deeply dented, the fear of another detective scapegoat, of more punishment and criticism from top management, the press and Joe Public, loomed large.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("That was why General John Afrika had sat in on the meeting at the DPCI tonight, and why he had asked for a specific investigator.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Fear. The Hawks did not usually accept orders or input from a provincial head of investigations. They were too protective of their independence, of their own structures.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Fear, he thought, was also the reason they were allowing the gunman to blackmail them. In the old days the SAPS would not have bowed to threats from a sharpshooter.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Griessel sighed, unlocked his office door. It was a recipe for trouble. Life was never simple.")]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("He arranged the files on his desk, first opening the slim one that John Afrika had given him. He began to read the emails in chronological order, initially struggling to focus, too many things had happened too fast tonight.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page15"
    }
  }), _c('a', {
    attrs: {
      "id": "page16"
    }
  })]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "marg"
  }, [_vm._v("762a89z012@anonimail.com")]), _vm._v(" "), _c('p', [_vm._v("Sent: Monday 24 January. 23.53")]), _vm._v(" "), _c('p', [_vm._v("To: j.afrika@saps.gov.za")]), _vm._v(" "), _c('p', [_vm._v("Re: Hanneke Sloet")]), _vm._v(" "), _c('p', [_vm._v("You know very well who murdered Hanneke Sloet. Arrest the communist, or I will hand everything to the press.")]), _vm._v(" "), _c('p', {
    staticClass: "margind"
  }, [_vm._v("The second one was much longer:")]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("762a89z012@anonimail.com")]), _vm._v(" "), _c('p', [_vm._v("Sent: Monday 31 January. 23.13")]), _vm._v(" "), _c('p', [_vm._v("To: j.afrika@saps.gov.za")]), _vm._v(" "), _c('p', [_vm._v("Re: Hanneke Sloet, you’re all going to hell!!!")]), _vm._v(" "), _c('p', [_vm._v("You are ungodly and sinners (1 Timothy 1:9, Proverbs 17:23).")]), _vm._v(" "), _c('p', [_vm._v("The truth will come out about the communist and about the money he is paying you. You are all equally corrupt. Your time is running out. 1 Timothy 1:9-10: Knowing this, that the law is not made for a righteous man, but for the lawless and disobedient, for the ungodly and for sinners, for unholy and profane, for murderers of fathers and murderers of mothers, for manslayers, for whoremongers, for them that defile themselves with mankind, for menstealers, for liars, for perjured persons, and if there be any other thing that is contrary to sound doctrine.")]), _vm._v(" "), _c('p', [_vm._v("Proverbs 17:23: A wicked man taketh a gift out of the bosom to pervert the ways of judgement.")]), _vm._v(" "), _c('p', [_vm._v("Proverbs 21:15: It is joy to the just to do judgement: but destruction shall be to the workers of iniquity.")]), _vm._v(" "), _c('p', {
    staticClass: "margind"
  }, [_vm._v("In the third he used a new tack:")]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("762a89z012@anonimail.com")]), _vm._v(" "), _c('p', [_vm._v("Sent: Sunday 6 February. 22.47")]), _vm._v(" "), _c('p', [_vm._v("To: j.afrika@saps.gov.za")]), _vm._v(" "), _c('p', [_vm._v("Re: Hanneke Sloet – on your conscience.")]), _vm._v(" "), _c('p', [_vm._v("You have three weeks to arrest Hanneke Sloet’s murderers. The process to let justice prevail has begun.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("I warned you twice, but you did nothing. What is to come is on your")]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v(" and your communist bedfellows’ consciences, not mine. You leave me no choice.")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', [_vm._v("Let justice be done.")]), _vm._v(" "), _c('p', {
    staticClass: "margind"
  }, [_vm._v("And then, the second last one, sent on Sunday 13 February, thirteen days ago:")]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("Ecclesiastes 3: To every thing there is a time.")]), _vm._v(" "), _c('p', [_vm._v("Verse 3: a time to kill, and a time to heal, a time to break down, and a time to build up.")]), _vm._v(" "), _c('p', [_vm._v("Verse 8: a time of war, and a time of peace.")]), _vm._v(" "), _c('p', {
    staticClass: "margind"
  }, [_vm._v("Griessel put the email down and arranged all five in a row, his eyes moving from one to the other.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Then he read them all over again.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', [_vm._v("When he was done, he propped his chin in his hands, and thought.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The dates of the emails. The pace had increased systematically. The first two were a week apart. Then six days. Then five. A fixed rhythm. Except for the last one.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Almost every one had been sent late at night.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("In the first and second emails, the references to ‘communist’. Singular. Then it became ‘murderers’. And ‘communist bedfellows’. But back to the singular ‘murderer’ in the last one.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The sudden jump to Bible verses, the religious justification, the building momentum of a crusade. But in the last one there was a stronger style, more confidence. And purpose. Suddenly a man with a mission.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He could understand why John Afrika and Zola Nyathi thought these were the words of a disturbed man. All the signs were there: crazies did their things at night. And they became increasingly urgent with the passage of time, their communications more frequent. They phoned, breathless and anonymous, or wrote, disjointed, often full of racism or conspiracy theories or warning of the Day of Judgement, of the gods’-vengeance-on-a-land-of-sinners.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page17"
    }
  }), _c('a', {
    attrs: {
      "id": "page18"
    }
  })]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("Like this one.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("They were usually media parasites, studying every piece that appeared about a case, reacting to it, quoting it, embroidering on it.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("This ")]), _vm._v("one didn’t do that.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("They almost always gave themselves a name when they wrote, some mythological or astrological or awe-inspiring pseudonym.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Not "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("this ")]), _vm._v("one.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("This one had a new tactic with every communication. This one went abruptly silent for two weeks before the final email. Which he had sent in daytime, a Saturday morning, twelve hours before he went out shooting.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("This one referred to a motive in the last email: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("You know why she was murdered.")])]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("This one had carried out his threats, he had done the one thing that would ignite the wrath of the SAPS – he had shot a policeman. And he was threatening to do it again.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Something was not right here.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He put the emails back one by one in their file and drew the hefty Sloet folder closer. He opened it, he wanted to start at the beginning, take a look at the murder scene first, the photos, the forensic report, the pathologists . . .")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Someone knocked on his door, softly and apologetically.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He was brought back from his reverie. ‘Come in,’ said Griessel.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Brigadier Musad Manie’s nickname in the DPCI was ‘the Camel’. Because ‘Musad’, one of the Hawk detectives had learned from a Muslim friend, meant ‘loose camel’ in Arabic. And when the tall, lean Colonel Zola Nyathi was appointed head of the Violent Crimes group – with his slow and stately, deliberate, slightly bent forward walk – he was swiftly dubbed ‘the Kameelperd’ or in the simpler English, ‘the Giraffe’.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("It was the Giraffe who ducked through the door now, his shaven head shining under the fluorescent lights of Griessel’s office.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘No, please, Benny, don’t get up . . .’ He walked up to the desk, his slender fingers putting down a car key.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘You can use the BMW.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Thank you, sir.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Benny, you know we’re a family here.’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page18"
    }
  }), _c('a', {
    attrs: {
      "id": "page19"
    }
  })]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Yes, sir.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘You know that we approach investigations as one big team.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Yes, sir. I just want to study the files first . . .’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘I understand that, Benny. But when you’re ready, get the guys involved. I’ve already called Vaughn, he’s on standby . . .’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Yes, sir.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Nyathi tapped a finger on the case files, his voice suddenly soft and confidential. ‘Look,’ he said. ‘You’re an old hand. I don’t have to spell it out for you . . .’ The colonel hesitated, lifted his head, looked Griessel right in the eyes. ‘You come talk to me, Benny. Or to the Brig. You find any monkey business anywhere, you come to us . . .’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Griessel didn’t know what to say.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Are you with me, Benny?’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Yes, sir,’ he said in the hope that he would be able to decipher what the Giraffe meant later.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Good.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Nyathi turned and walked to the door. Just before he closed it, he said: ‘Good luck.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Griessel sat and looked at the door. Manie and Nyathi had also been taken by surprise over this affair, by Afrika’s request and involvement. They were playing along, but cautiously.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He shook his head. Politics. Not his favourite game.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("But he appreciated Nyathi’s gesture. The problem was that he was not entirely convinced of this we-are-one-big-family-and-we-work-as-a-team strategy of the Hawks. He hadn’t been part of the unit for even three weeks, he had only recently learned that JOC stood for Joint Operational Centre – group heads and detectives of the various DPCI units thrown together under one operational leader to investigate a case. Too many people - a recipe for chaos. He was accustomed to one shift partner, or to working alone, especially during the past year when he had been in Afrika’s office.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He sighed. He still had no idea why Afrika had transferred him to the Hawks.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He reached for the case file, took out the crime-scene photographs one by one and arranged them in rows in front of him.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("In full colour, Hanneke Sloet lay on the big, highly polished marble tiles beside a single round pillar. The red-black blood in stark contrast")]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v(" to her sleeveless white dress and the light grey floor. She lay on her back, right arm over her body, the right hand pressed to the wound in her belly. She had tried to stem the massive blood loss to the very end.")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("Her bare left arm was slightly outstretched, her hand open.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Her head on the floor, the back of the skull resting in blood, her dark hair fallen across her face, covering her eyes and nose, but the mouth was visible. A full mouth, dark red lipstick, almost the same colour as the blood.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She was barefoot, the dress with the skirt shifted up, her legs exposed to far above the knee.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("It looked like a single wound, just below and to the right of her heart.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He wanted to get a feel for the scene, and studied the photos one by one. The apartment was new and modern, the walls and the single pillar were snow white, the floor grey and shiny, the windows large and without curtains – they looked out on a wide balcony outside, and over the multicoloured Bo-Kaap and Signal Hill.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Sloet lay in a spacious room. Behind her, in the centre, was a white couch and two chairs, square and stylish, on a loose white shagpile carpet. Against the long wall was one huge, unframed picture, the kind of modern art that Griessel did not understand – shapes and stripes in white and grey, like an aerial photo of waves in the sea. A single glass-and-chrome shelf housed a hi-fi system and two small speakers.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("In the corner furthest from where Sloet lay, there was a spiral staircase that led to an upper level – gleaming light brown wood, with a narrow stainless steel rail.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("At the window, a white telescope on a tripod pointed at the buildings of the city.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Behind the pillar there was a small open-plan kitchen – modern cupboards behind opaque olive-green glass, and an angular chrome-coloured fridge.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The front door was three metres to the left of the kitchen, and four metres from where Hanneke Sloet’s lifeless body lay.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He looked at the last row of photos, of the two bedrooms in the apartment. The larger one was clearly where Sloet had slept. For the most part it was painfully neat. A wide double bed on a square white platform. The bed was made up with snow-white linen, with two dark brown pillows, matching the dark wood of the bedside cupboards.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page20"
    }
  }), _c('a', {
    attrs: {
      "id": "page21"
    }
  })]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("The desk, a smooth white wooden top on two brown trestles, bore the only signs of activity: a laptop, a pair of folders, one of which was open, a fountain pen, uncapped. A glass of red wine, three-quarters empty, an Apple iPhone. The brown high-backed chair was pushed back, turned a little to the side. A brown standard lamp to the right was switched on.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The second bedroom was smaller. A single bed, without bedding, cardboard boxes on it, unopened. An empty white bookshelf, two rolled-up Persian carpets.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Griessel picked up the thick folder and placed it in front of him, on top of the photos. Like all SAPS case files it consisted of three parts: Section A contained the interviews, reports, statements and the photo album; in Section B the correspondence between SAPS departments, or other concerns such as banks or employers, was stored; Section C was the journal of the investigation on the SAPS5 form, this one comprised a detailed, chronological history of the case, with references to documents in Section A.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He paged to the pathologist’s report in Section A, and was relieved to see that Prof Phil Pagel had done the autopsy. Pagel was the smartest man he knew, vastly experienced, extremely thorough. Above all, Pagel knew how to write a report so that detectives could both understand and use it. At the top there was always a summary that made the investigating officer’s life easier – normal language, numbered points, short sentences and paragraphs, useful information.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Griessel read:")])]), _c('ul', {
    staticStyle: {
      "list-style-type": "disc"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('li', [_c('p', [_c('em', {
    staticClass: "italic"
  }, [_vm._v(" Time of death: Between 20.00 and 0.00 on Tuesday, 18 January. Probably around 22.00.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('em', {
    staticClass: "italic"
  }, [_vm._v(" Cause of death: radical loss of blood due to a single stab wound from the front, 8 mm above the fourth rib, 20 mm left of the breastbone (gladiolus), through the left lobe of the liver and the inferior vena cava (the large artery, carrying oxygen-poor blood from the lower body to the heart), to the T7 vertebra.")])])])]), _c('li', [_c('a', {
    attrs: {
      "id": "page21"
    }
  }), _c('p', [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v(" Wound pathology and weapon: the wound pathology indicates a stabbing object with, most likely, a sharp point (very even angle) and a double, asymmetrical cutting edge (diamond geometry?). The blade is apparently straight. The measurements of the blade are probably 6.5")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("to 7.5 cm wide, 1.5 cm thick, and longer than 20 cm (no bruising from a handle or hilt. The stabbing angle 85 to 105° relative to vertical torso.")])])])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('li', [_c('p', [_c('em', {
    staticClass: "italic"
  }, [_vm._v(" A single, fatal stab wound and the complete absence of defensive wounds to hands indicates significant violence of the stabbing action, or a very sharp blade, or a combination of the two. (Surprise attack?) (Home-made weapon? Assegai? Ornamental dagger? Sword?)")])])]), _vm._v(" "), _c('li', [_c('p', [_c('em', {
    staticClass: "italic"
  }, [_vm._v(" Wound pathology and suspect: suspect is probably 200 to 400 mm taller than the victim (size of weapon, angle of stab wound, possibility of considerable violence). Single stab wound and unknown weapon prevents further speculation.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('em', {
    staticClass: "italic"
  }, [_vm._v(" Wound residue: none.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('em', {
    staticClass: "italic"
  }, [_vm._v(" No indication of sexual activity.")])])])])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("With the new information in mind, Griessel examined the crime-scene photos again. Stabbed only once. She lay four metres from the front door, and there were no cuts on her hands to show that she had tried to defend herself.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("No obvious signs of robbery, the brigadier had said. And according to Pagel, no signs of sex. That meant an absence of semen, of bruising on the victim.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He wondered who had found the victim. How did the building’s security work? He paged through Section A, looking for statements, found a white A4 envelope, loosely inserted behind the photograph album. Someone had written a single word on it in blue pen: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sloet")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He opened it, removed the contents.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Three large colour prints. Of a living Hanneke Sloet.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("They excited him immediately, making him forget what he was looking for.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("All three photos had been taken in a studio, under professional lighting. In the first, only her head, right shoulder and part of her arm were visible. She wore a thin white dress, etched against the smooth, tanned skin of her shoulder and arm. Her head was angled to the right, she was looking down, her eyes veiled, the right side of her face in dark shadow that accentuated the full lips and strong cheekbone. A single strand of hair draped across her face, down to her chin. The shoulder")]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v(" and arm were feminine, muscular. The grey background was an interesting texture, out of focus.")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("It was quite a sensual photo.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Lovely woman. And she knew it. She liked it, she was displaying it a little.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The second photo was of her upper body, her head slightly dipped so that her dark eyes looked up at the camera. She had an easy smile, showing a narrow gap between her front teeth. Her hair was tied back now. A thin, tight-fitting and collarless blouse with a low neckline displayed the full, prominent breasts, with a certain innocence.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The third was a nude study, dark and artistic. Tasteful. The background was pitch black, the lighting from the right and behind, her body turned, so that only a cheekbone, the tip of her nose, a large, round earring, the slim line of her neck, a shoulder, a single perfect breast and nipple, a hip and the outline of her leg were visible.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He suspected the photos had been taken recently, she seemed mature, close to her age of thirty-three, according to the file.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He arranged the photographs in a row. Looked over them again. What personality, what reason had motivated her to go to all this trouble? How many hours, to make the appointment with the photographer, choose the right clothes, complete the photo sessions? This woman, the corporate lawyer.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("And the breasts. Unnaturally large and perfect, like someone who had had them surgically enhanced.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("For whose benefit? he wondered. For whom had she had the photos taken?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He sat there staring, fascinated by this smouldering woman.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("His cellphone rang, sudden and shrill.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He returned to the present with a vague feeling of guilt, had to look around for the phone first. He found it in the pocket of his jacket, hanging over the chair. He took it out: ALEXA, the screen read.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Fuck. He ought to have called her. He looked at his watch. It was nearly eleven.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He answered: ‘Alexa, I’m so sorry . . .’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘No, this is not Alexa,’ said a man’s voice. Hostile. ‘She asked me to call you to come and collect her.’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page23"
    }
  }), _c('a', {
    attrs: {
      "id": "page24"
    }
  })]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Where is she?’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘She’s drunk, sir. Falling down drunk.’")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', [_vm._v("He jogged to the car with the files in his arms and the knowledge that it was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("his ")]), _vm._v("fault. He had embarrassed her, left her alone, kept her in the dark. She had been sober for a hundred and fifteen days and now he had driven her back to drink.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He opened the rear door of the BMW 130i, put the files on the back seat, slammed the door shut in frustration, got in the front and drove away.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He should have known that Alexa used to drink because she suffered from stage fright, and tonight was a sort of stage, her first interaction with the music people in years, her timid return to the limelight. He should have thought, should have controlled his language and his reactions. He should have told the brigadier he couldn’t come right away, he should have taken Alexa home first. But no, all he could think of was his own humiliation. He was a dolt, a fucking idiot policeman.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("What was wrong with him?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Doc Barkhuizen’s warning flashed through his head: ‘Careful, Benny, you haven’t been dry a year yet. Two alcoholics . . . that’s double the risk.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He had protested and said they were only friends, he could support her, encourage her, they could attend AA gatherings together. And Doc had just shaken his head and said, ‘Careful.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("How had he supported her tonight?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He should have listened to Doc. Doc knew the ‘just friends’ explanation was a smokescreen. Doc could see he "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("liked ")]), _vm._v("Alexa. More and more.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("And she liked him, he had thought.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("And now? Now he’d fucked it all up.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("Why did he always do that? Why was his life never simple? Never fucking ever. He was forty-five, the age at which you are supposed to reach inner calm and wisdom and resignation, the age at which you are supposed to have all your life shit sorted out. But not him. His life")]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v(" was constant chaos. An endless stream of trouble, a never-ending struggle to cope. But he just could not win, it was one thing on top of another. You could never get ahead.")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("He had only just, this past month, started to get used to the whole divorce thing, tried to make peace with the fact that he and Anna were over. Totally, irretrievably over. He still struggled with the fact that she was ever more seriously involved with a lawyer. A fucking lawyer. But he was working on that, fuck knows, he was trying.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He had cut back to pay the maintenance, and his contribution to Carla’s studies, and he could almost live with that, though he felt he was being ripped off, he paid far more than Anna, and they earned about the same.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He’d worked hard the past weeks to fit in with the Hawks, the new relationship, the new structures, the new ranks. Everybody’s rank had changed, back to the military hierarchy of the old days. Everybody’s except his own, because a captain was still a captain. But he had accepted that too.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He had got back into a routine with his children. Carla, who was studying drama at Stellenbosch. Drama, as though she hadn’t had enough drama in her life with an alcoholic policeman father and the whole divorce disaster. Drama. Where would the child find work? And his son, Fritz, who might or might not pass Matric, because he was playing guitar for Jack Parow’s band. Jack Parow. Hip hop or rap or whatever you called it, swore worse than a policeman. But what could he do? Fritz had talent – Jack had approached him personally, come and play for me. Griessel had made peace with the fact that the world had changed, that children had choices today, that their approach to careers was different.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Peace with many things. On the brink of getting things straight.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("And now in one night he had made a complete arse of himself in front of three people for whom he had immense respect: Anton Goosen, Lize Beekman, and Alexa Barnard. And driven the last one to drink.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He would just have to accept it. He was a fuck-up.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("The words hung for a moment in his thoughts and he realised: it was the swearing. That was the problem, the thing that had caused all the trouble tonight. Here, now, it had to end. He was through with")]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v(" swearing. Finished. For the rest of his life. The same way he had stopped drinking, he would stop fucking swearing too.")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("And tomorrow, when she was sober, he would explain to Alexa about the Sloet case and ask her forgiveness, and get her to phone the other two, so she could tell them, it was all due to admiration and nerves, maybe it happened to other people too, maybe he wasn’t the first.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("And then he thought how beautiful Alexa had looked and his fleeting hope, at her house, that he would get lucky tonight, and he snorted in disgust at himself, at "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("this ")]), _vm._v("world, in his Hawks BMW on the N1. And he thought, life is never fu—Damn. Life is never "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("flipping ")]), _vm._v("simple.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He found no pleasure in his new word.")]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("He stopped at the Artscape. His cellphone rang. It must be the centre manager again, about Alexa. He answered hastily, to say he had arrived.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Griessel.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Captain, it’s Tommy Nxesi from Green Point.’ There was a wary note to his voice.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("It took a moment to register – it was the warrant officer who had originally investigated the Sloet case.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Yes, Tommy.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Captain, do I still have to come in?’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘No . . .’ he realised the detective had been waiting for him to call, at the request of John Afrika. ‘Sorry, Tommy, I should have let you know . . .’ Griessel thought of what lay ahead, with Alexa. ‘You don’t need to . . . Can we talk tomorrow?’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘So, you don’t need me tonight?’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘No, thanks a lot . . .’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘OK,’ said Tommy, relieved.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Thanks . . .’ then he remembered, he wanted to have a look at the scene of the crime. ‘Tommy, do you still have the keys to Sloet’s apartment?’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Not here with me.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘No, I mean tomorrow morning – can we take a look tomorrow morning?’ And then he hurried to add – knowing how Nxesi would feel about it, he had been in the same position himself, ‘You’re the expert on this one. I want to hear what "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you ")]), _vm._v("think.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Sure, Captain. What time?’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page26"
    }
  }), _c('a', {
    attrs: {
      "id": "page27"
    }
  })]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Nine o’clock?’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘See you there, thanks, Captain.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Griessel put the phone back in his pocket.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He would have to keep his wits about him.")]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("He was shocked when he saw her in the manager’s office. Her makeup was smudged, her hair hung over her face, a mess, the neckline of her dress had slipped down too far, a sandal lay to one side, the other on her foot. She sat on a chair with her legs apart, elbows on her knees, swaying from side to side.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Alexa . . .’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She looked up slowly. He could see she was very drunk. She battled to focus. Then slowly her face crumpled. She tried to straighten up, but it was hard. She began to cry.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He went to her, helped her up, tried to pull her dress higher, but she wrapped her arms around him. She smelled of liquor and perfume.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘I’m here,’ he said. ‘I’m sorry.’ He put his arms around her, held her tightly.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Her face was in his neck and he felt the hot, wet tears trickling down him. ‘I’m such . . .’ she said, the sibilants coming out with difficulty. ‘I’m such a loser, Benny.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘You’re not,’ he said.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The manager stepped around them, bent and picked up her sandal and her little evening bag that was hanging over the arm of the chair. He held them out to Griessel, the shoe by one finger, as though it was contaminated, disgust on his face.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Benny took the shoe and the bag. Alexa sagged against him.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Come,’ he said gently. ‘Let’s go home.’")]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("In the car she talked disjointedly, her head against the window.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Intruder, Benny. That’s all I am . . . they know . . .’ She struggled to open her bag, took out her cigarettes, dropped the lighter.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He didn’t want to see her like this, because it was his doing. He searched for words to repay, to console her, but all he could manage was: ‘I’m so terribly sorry.’")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("It was as though she didn’t hear him. She grabbed for the lighter on the floor, surrendered the battle, fell back in her seat and began a")]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v(" chorus: ‘They saw "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("through ")]), _vm._v("me.’ Repeating it over and over, that maudlin tone of drunken self-pity.")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("His cellphone rang, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jissis")]), _vm._v(", what "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("now")]), _vm._v("? He answered it.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Benny, this is John Afrika. Cloete says a small article will appear on page fourteen of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Weekend Argus")]), _vm._v(", and on the Internet, we were too late for anything else. It’s a mess, Benny, I’m telling you. Anyway, I just wanted to let you know, you’ll have to produce results. Pull out all the stops.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Yes, General.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘OK, Benny.’ Afrika concluded the call.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘They saw through me,’ said Alexa.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He parked in front of her house, found her key in the evening bag. He got out.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Don’t leave me,’ she pleaded, the voice of a child.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He got back in. ‘I won’t leave you. I just want to unlock the door.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She looked at him uncomprehendingly. ‘I’m an alcoholic, you know.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He nodded, got out again, walked quickly to the front door, unlocked it. Jogged back to the car, opened the passenger door. ‘Let’s get you in the house.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She didn’t respond, just sat there, swaying again.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Please, Alexa.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She lifted her left arm slowly. He bent, pulled her arm over his back, pulled her up and out. She was unsteady. He shuffled through the gate with her, up onto the veranda. Inside he struggled to find the light switch, then he helped her slowly up the stairs. Her other sandal came off, rolled down two steps. They shuffled down the passage, into her room. He sat her down on the bed. She toppled sideways, her head on the bedspread. He switched on the bedside light, stood a moment undecided.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He had to fetch her bag, in the car. Had to lock the vehicle.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Her lips moved, she murmured something.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Alexa . . .’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He brought his head close, so he could hear what she said. But she didn’t speak. She sang. The song that had made her famous. ‘Soetwater’, Sweet Water. Softly, nearly inaudible, but perfect, in tune, in her unique, rich voice.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page28"
    }
  }), _c('a', {
    attrs: {
      "id": "page29"
    }
  })]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-left": "5.5em",
      "margin-top": "1em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A small glass of sunlight,")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "5.5em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A goblet of rain")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "5.5em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Pour sweet water")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "5.5em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A small sip of worship,")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "5.5em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A mouthful of pain")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "5.5em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Drink sweet water.")])]), _vm._v(" "), _c('p', {
    staticClass: "marg1"
  }, [_vm._v("‘I’m just going to lock the car,’ he said.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("No response.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He walked fast. On the way down the stairs he remembered she had tried to commit suicide, the last time she had been drunk. When her husband had died.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He would have to stay here tonight.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He fetched the handbag, her cigarettes and lighter, then the stack of files, locked the car, and jogged back.")]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("With her clumsy assistance he got both big earrings off and put them on the bedside cupboard. ‘Try to sleep a little,’ he said.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She looked at him with new focus and control. Her lips opened slightly. She put her hands behind his head and pulled him closer and kissed him, her mouth open and wet, he tasted alcohol on her. She pulled him down, to the bed.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He put his hands carefully on her shoulders, pushed her away gently.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She wept. ‘You don’t want me either.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘I do,’ he said. ‘But not like this.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Eventually she lay back against the cushions. He picked up her legs, put them on the bed. She turned her back to him. He walked around the bed, found the edge of the bedspread and folded it over her.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Then he stood there, for ten minutes, and listened as her breathing slowed. Until she slept.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He looked at his watch. It was ten past twelve. Sunday morning.")])])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6df5364c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/day_01.vue
// module id = 75
// module chunks = 0